module.exports = __webpack_public_path__ + "img/CodeDeploy.0d3fd303.png";